import { render, staticRenderFns } from "./FixedIcons.vue?vue&type=template&id=6f133ddc&scoped=true&"
import script from "./FixedIcons.vue?vue&type=script&lang=js&"
export * from "./FixedIcons.vue?vue&type=script&lang=js&"
import style0 from "./FixedIcons.vue?vue&type=style&index=0&id=6f133ddc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f133ddc",
  null
  
)

export default component.exports